const tableOfContent = () => {
    const tocItems = document.querySelectorAll('.content-list > .toc-item');
    const tocSubItems = document.querySelectorAll('.sub-content-list .toc-sub-item');
    const allItems = document.querySelectorAll('.toc-item, .toc-sub-item');

    const tocHeader = document.querySelector('.toc-header');
    const tocContent = document.querySelector('.toc-content');

    if (!tocHeader || !tocContent) return;
    // Toggle functionality for TOC header
    tocHeader.addEventListener('click', function() {
        const isCollapsed = tocContent.classList.contains('collapsed');

        if (isCollapsed) {
            // Expand
            tocContent.classList.remove('collapsed');
            tocContent.classList.add('expanded');
            tocHeader.classList.remove('collapsed');
        } else {
            // Collapse
            tocContent.classList.remove('expanded');
            tocContent.classList.add('collapsed');
            tocHeader.classList.add('collapsed');
        }
    });

    // Handle main TOC item clicks
    tocItems.forEach(item => {
        const link = item.querySelector(':scope > a');
        if (!link) return;

        link.addEventListener('click', function(e) {
            e.preventDefault();

            // Remove active class from all items
            allItems.forEach(tocItem => tocItem.classList.remove('active'));

            // Add active class to clicked item
            item.classList.add('active');

            // Smooth scroll to target section
            const targetId = this.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });

                // Update URL hash
                history.pushState(null, null, '#' + targetId);
            }
        });
    });

    // Handle sub-item clicks
    tocSubItems.forEach(subItem => {
        const link = subItem.querySelector('a');
        if (!link) return;

        link.addEventListener('click', function(e) {
            e.preventDefault();

            // Remove active class from all items
            allItems.forEach(tocItem => tocItem.classList.remove('active'));

            // Add active class to clicked sub-item and its parent
            subItem.classList.add('active');
            const parentItem = subItem.closest('.toc-item');
            if (parentItem) {
                parentItem.classList.add('active');
            }

            // Smooth scroll to target section
            const targetId = this.getAttribute('href').substring(1);
            const targetSection = document.getElementById(targetId);

            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });

                // Update URL hash
                history.pushState(null, null, '#' + targetId);
            }
        });
    });
};

export default tableOfContent;